import { map, pipe } from 'rxjs';

export const sortBroadcastedAt = () => pipe(
  map((el) => el.sort((a, b) => b.broadcastedAt - a.broadcastedAt))
);
